import { Component } from '@angular/core';

@Component({
  selector: 'public-app-root',
  templateUrl: './public-app.component.html',
  styleUrls: ['./public-app.component.css'],
  standalone: false
})
export class PublicAppComponent {}